import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DecadenceGameAssets} from "../DecadenceGameAssets";
import {gsap} from 'gsap';
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Decadence} from "../Decadence";
import {IWinRatioConfig} from "../config/DecadenceWinConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";

export class DecadanceWinCounterView extends PIXI.Container implements StageLayer {
    // Maybe this should be handled somewhere else..
    private bgDarken:PIXI.Sprite;
    //private bigWinAnimation:PIXI.spine.Spine;

    private winAmount:number;
    private winText:PIXI.BitmapText;
    public fadeDuration:number = 0.1;

    private winCapCountUpPos:PIXI.Point = new PIXI.Point(360, 500);
    private defaultCountUpPos:PIXI.Point = new PIXI.Point(360, 555)

    constructor() {
        super();
        this.name = "Win Counter";

        this.bgDarken = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgDarken.tint = 0x000000;
        this.bgDarken.anchor.set(0.5, 0.5);
        this.bgDarken.alpha = 0.7;
        this.bgDarken.visible = false;
        this.addChild(this.bgDarken);

        this.winAmount = 0;
        this.winText = new PIXI.BitmapText(`${this.winAmount}`, {
            fontName: DecadenceGameAssets.BITMAP_FONT_COUNTUP,
            fontSize: 120
        });
        this.winText.tint = 0x00ff00;

        this.winText.alpha = 0;
        (<PIXI.Point>this.winText.anchor).set(0.5, 0.5);
        this.addChild(this.winText);
        this.winText.position.copyFrom(this.defaultCountUpPos);

        this.onResize();
    }

    private formatWinAmountText() {
        this.winText.scale.set(1,1);
        this.winText.text = SlotGame.apiPlugin.currency.formatValue(this.winAmount);
        if(this.winText.width > 700) {
            const newScale = 700 / this.winText.width;
            this.winText.scale.set(newScale, newScale);
        }
    }


    onResize() {
        //this.position.set(360, 360);
        this.bgDarken.width = NolimitApplication.screenBounds.width;
        this.bgDarken.height = NolimitApplication.screenBounds.height;
    }

    public countUp(from:number, to:number, duration:number = 1, tint?:number):gsap.core.Timeline {
        return gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winText.position.copyFrom(this.defaultCountUpPos);
                this.winAmount = from;
                if(tint) {
                    this.winText.tint = tint;
                }
            })
            .add(gsap.to(this.winText, {alpha: 1, duration: this.fadeDuration}))
            .add(gsap.to(this, {winAmount: to, duration: duration}), "<")
    }
    public countUpWincap(from:number, to:number, duration:number = 1, tint?:number):gsap.core.Timeline {
        return gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winText.position.copyFrom(this.winCapCountUpPos);
                this.winAmount = from;
                if(tint) {
                    this.winText.tint = tint;
                }
            })
            .add(gsap.to(this.winText, {alpha: 1, duration: this.fadeDuration}))
            .add(gsap.to(this, {winAmount: to, duration: duration}), "<")
    }

    public playBigWinCountUp(winConf:IWinRatioConfig, from:number, to:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        // Show Image and count up
        tl.add(() => {
            //SpineGSAPWrapper.resetSpineState(this.bigWinAnimation);
            const animation = "L" + winConf.bigWinLevel;
            //this.bigWinAnimation.alpha = 1;
            //this.bigWinAnimation.state.setAnimation(0, animation, false);
            this.bgDarken.visible = true;
            this.bgDarken.alpha = 0.7;
        }, "<");

        tl.add(this.countUp(from, to, winConf.duration), "<");

        return tl;
    }


    public show(amount:number|undefined = undefined, ways?:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                if(amount) {
                    this.winAmount = amount;
                }
                this.formatWinAmountText();
            })
            .add(gsap.to(this.winText, {alpha: 1, duration:this.fadeDuration}))
    }

    public hide():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.winText, {
                alpha: 0,
                duration: this.fadeDuration,
            }), "<")
            .add(gsap.to(this.bgDarken, {
                alpha: 0,
                duration: this.fadeDuration,
                onComplete: () => {
                    this.bgDarken.visible = false;
                }
            }), "<")
    }

    public resetState() {
        this.winText.alpha = 0;
        this.winAmount = 0;
        this.position.set(360, 360);
    }
}